<template>
  <div class="contenedor">
    <div v-if="isValid"></div>
    <div v-else class="box">
      <div class="part1"></div>
      <div class="part2">
        <div class="login">
          <div class="interLogin">
            <h1  class="camposForm" styae="color: white;">Bienvenidos </h1>
            <input class="camposForm campo" type="text" v-model="usuario" placeholder="Usuario">
            <input class="camposForm campo" type="password" v-model="contrasena" placeholder="Contraseña">
            <button class="camposForm" @click="login" style="background-color: rgba(96, 62, 28, 1);color: white;">Iniciar sesión</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/*
alLogearse(estado)
*/
import {Login} from '@/Apis/ApisUsuarios.js'

export default {
  name: "ComponentLogin",
  props: { 
    estado: {
      require: true
    } 
  },
  data: () => ({
    usuario: '',
    contrasena: ''
  }),
  methods: {
    login(){
      Login(this.usuario,this.contrasena).then(
        response => {
          console.log(response) 
          this.$emit('alLogearse', response.valido);
        }
      ).catch(err => {
        console.error("Error en login:", err);
        this.$emit('alLogearse', false);
      });
    }
  }
}
</script>

<style scoped>
/* Contenedor que ocupa TODA la pantalla */
.contenedor {
  width: 100vw;
  height: 100vh;
  background-image: url('@/assets/FondoHamburgueza.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  box-sizing: border-box;
}

/* Cuadro de login centrado y proporcional */
.box {
  width: 90%;
  height: 80%;
  border-radius: 15px;
  display: flex;
  flex-direction: row;
  padding: 20px;
  box-sizing: border-box;
}

/* Estilos internos */
.part1 {
  flex: 6;
}
.part2 {
  flex: 5;
}
.part1, .part2 {
  margin: 5px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.login{
  display: block;
  height: 100%;
  width: 100%;
  opacity: 0.9;
  border-radius: 40px;
  background-color: rgba(38, 18, 0, 0.9);
}


@media (max-width: 868px) {
  .box {
    flex-direction: column; /* opcional, en caso quieras columna en móviles */
  }

  .part1 {
    display: none;
  }

  .part2 {
    flex: 1 1 100%;
    width: 100%;
    margin: 0;
  }
}

.interLogin{
    margin: 50px;
    display: block;
    height: calc(100% - 100px);
}

/*diseño campos dentro de caja*/
.camposForm{
  display: block;
  width: calc(100% - 60px);
  margin: 30px;
  font-size: 45px;
  border-radius: 20px;
  text-align: center;
  font-family: Arial, Helvetica, sans-serif;
  font-stretch: 700px;
}
.campo {
  text-align: left;
}


.campo:hover{
  cursor:text;
}
</style>

<!-- Estilo global para evitar scrolls molestos -->
<style>
html, body {
  margin: 0;
  padding: 0;
  height: 100%;
  overflow: hidden;
  font-family: sans-serif;
}


</style>
